import { EVALUATE_HEALTH_TESTS, COMPANIES_TESTS, ONLY_360_USERS_TESTS, NOT_IN_MX_TESTS } from "@/constants/patientServices"

export function testToShow (companyServices, inMx, professionalOrCenter = false) {
    var totalTests = EVALUATE_HEALTH_TESTS
    if (professionalOrCenter) {
        return totalTests
    }
    if (companyServices.length != 0) {
        return totalTests.filter(testId => companyServices.some(s => s.id === testId))
    } else {
        return totalTests.filter(testId => !COMPANIES_TESTS.some(item => item === testId) && !ONLY_360_USERS_TESTS.some(item => item === testId)).filter(testId => inMx ? !NOT_IN_MX_TESTS.some(item => item === testId) : true)
    }
}

export function testRoute (testId) {
    switch (true) {
        case testId === 'ryff-scale':
            return 'tests/bienestar-psicologico'
        default:
            return `tests/${testId}`
    }
}


// WEBPACK FOOTER //
// ./src/helpers/tests.helpers.js